exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".addStudentsMethodSelect{margin-bottom:10px}.addStudentsMethodSelect .methodOptions{margin-left:auto;margin-right:auto;text-align:center}.addStudentsMethodSelect .largeObject{display:inline-block;vertical-align:top;width:13rem;margin:1rem}.addStudentsMethodSelect .methodObjectContent{text-align:center;width:10rem;margin:2rem auto}.addStudentsMethodSelect .selectedOption{background:#c0f2aa}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/sass-loader/dist/cjs.js!./assets/sass/org/roster_upload/add_students_method_select.scss
// module id = 1339
// module chunks = 0